export const DOUBT_DESK_CSS = `
/* the desk sizes itself to the viewport, so the page itself must not scroll:
   .content-wrapper's own min-height:100vh sits inside .main-wrapper's 55px/40px padding.
   Dropping that bottom padding lets the card run to the foot of the window with an
   even 10px gutter above and below. */
.main-wrapper.dd-main { padding-bottom:0; }
.content-wrapper.dd-fit { min-height:0; padding-top:0; }
.dd-page { padding:10px 14px; }

.doubt-desk {
    --dd-accent:#36a1f5;
    --dd-accent-dark:#1e80ce;
    --dd-accent-soft:#e0f2fe;
    --dd-accent-tint:#eff6ff;
    --dd-accent-line:#bae6fd;
    --dd-surface:#ffffff;
    --dd-surface-alt:#f8fafc;
    --dd-surface-mute:#f1f5f9;
    --dd-border:#e2e8f0;
    --dd-border-strong:#cbd5e1;
    --dd-text:#0f172a;
    --dd-text-soft:#475569;
    --dd-muted:#64748b;
    --dd-faint:#94a3b8;
    --dd-amber:#d97706; --dd-amber-bg:#fef3c7; --dd-amber-line:#fde68a;
    --dd-blue:#0284c7; --dd-blue-bg:#e0f2fe; --dd-blue-line:#bae6fd;
    --dd-green:#059669; --dd-green-bg:#d1fae5; --dd-green-line:#a7f3d0;
    --dd-red:#ef4444;

    font-family:inherit;
    color:var(--dd-text);
    background:var(--dd-surface);
    border:1px solid var(--dd-border);
    border-radius:16px;
    box-shadow:0 4px 16px rgba(15,23,42,.04);
    /* visible so the date-range popup can escape the card; the workspace below
       keeps its own clipping for the rounded bottom corners */
    overflow:visible;
    display:flex;
    flex-direction:column;
    height:calc(100vh - 75px);
    min-height:460px;
}

/* ---------- TOP BAR ---------- */
.doubt-desk .dd-topbar {
    display:flex; align-items:center; justify-content:space-between; gap:16px;
    background:var(--dd-surface);
    border-bottom:1px solid var(--dd-border);
    padding:14px 22px;
    flex-shrink:0;
    border-radius:15px 15px 0 0;
    /* the date-range panel drops out of here over the workspace below */
    position:relative; z-index:40;
}
.doubt-desk .dd-brand { display:flex; align-items:center; gap:12px; }
.doubt-desk .dd-brand-mark {
    width:38px; height:38px; border-radius:10px; flex-shrink:0;
    background:linear-gradient(135deg,#36a1f5 0%,#1e80ce 100%);
    color:#ffffff; font-weight:700;
    display:flex; align-items:center; justify-content:center; font-size:15px;
    box-shadow:0 4px 12px rgba(54,161,245,.3);
}
.doubt-desk .dd-brand-text h1 {
    font-size:1.15rem; font-weight:700; color:var(--dd-text); margin:0; line-height:1.25;
}
.doubt-desk .dd-brand-text span { font-size:.75rem; color:var(--dd-muted); }

/* ---------- WORKSPACE ---------- */
.doubt-desk .dd-workspace {
    flex:1; display:flex; overflow:hidden; min-height:0;
    border-radius:0 0 15px 15px;
}

/* aligned on the bottom edge so the button sits level with the date field,
   which carries a label above it */
.doubt-desk .dd-topbar-actions {
    display:flex; align-items:flex-end; justify-content:flex-end; gap:10px; flex-wrap:wrap;
}
.doubt-desk .dd-topbar-actions .dd-field { height:34px; width:auto; }

/* shared range picker (ProfileDateBlock) sized for the top bar */
.doubt-desk .dd-date-range { display:flex; flex-direction:column; gap:3px; }
.doubt-desk .dd-date-range > label {
    font-size:.66rem; font-weight:700; letter-spacing:.5px; text-transform:uppercase;
    color:var(--dd-muted); margin:0;
}
.doubt-desk .dd-date-range { position:relative; z-index:50; }
.doubt-desk .dd-date-range .customDaterange { width:230px !important; position:relative; }
/* the popup is ~640px wide: let it sit above the columns and stay on screen */
.doubt-desk .dd-date-range .daterangepicker {
    z-index:60 !important;
    max-width:calc(100vw - 24px);
    max-height:calc(100vh - 150px);
    overflow:auto;
    box-shadow:0 12px 32px rgba(15,23,42,.18);
    border-radius:10px;
}
.doubt-desk .dd-date-range .form-control {
    height:34px !important; min-height:34px; line-height:1.2;
    padding:0 10px 0 32px; border-radius:8px; border:1px solid var(--dd-border-strong);
    font-size:.78rem; color:var(--dd-text); background:var(--dd-surface);
}
.doubt-desk .dd-date-range .form-control:focus {
    border-color:var(--dd-accent); box-shadow:0 0 0 3px rgba(54,161,245,.15);
}
.doubt-desk .dd-date-range i.fa-calendar-day,
.doubt-desk .dd-date-range i.far {
    position:absolute; left:11px; top:50%; transform:translateY(-50%);
    z-index:2; color:var(--dd-accent); font-size:.82rem; pointer-events:none;
}
.doubt-desk .dd-new-doubt-btn {
    flex-shrink:0; height:34px; padding:0 22px; border-radius:30px; border:none; white-space:nowrap;
    display:inline-flex; align-items:center; justify-content:center;
    background:linear-gradient(135deg,#36a1f5 0%,#1e80ce 100%); color:#ffffff;
    font-weight:700; font-size:.8rem; cursor:pointer; font-family:inherit;
    box-shadow:0 4px 14px rgba(54,161,245,.4); transition:all .2s ease-in-out;
}
.doubt-desk .dd-new-doubt-btn:hover {
    transform:translateY(-2px); box-shadow:0 6px 20px rgba(54,161,245,.5);
    background:linear-gradient(135deg,#4cb0ff 0%,#2992e4 100%);
}

/* ---- thread list column ---- */
.doubt-desk .dd-threads {
    width:340px; flex-shrink:0; background:var(--dd-surface-alt);
    border-right:1px solid var(--dd-border); display:flex; flex-direction:column;
}
.doubt-desk .dd-threads-head {
    padding:14px 16px 12px; border-bottom:1px solid var(--dd-border);
    background:var(--dd-surface); flex-shrink:0; position:relative; z-index:5;
}
/* the three filters share the row equally, at one height */
.doubt-desk .dd-filter-row { display:flex; align-items:center; gap:10px; margin-top:8px; }
.doubt-desk .dd-filter-row > * { flex:1 1 0; min-width:0; }
.doubt-desk .dd-filter-row .dd-field { height:38px; }
.doubt-desk .dd-search { height:38px; }
.doubt-desk .dd-field {
    width:100%; border:1px solid var(--dd-border-strong); border-radius:8px; padding:8px 10px;
    font-family:inherit; font-size:.82rem; background:var(--dd-surface); color:var(--dd-text);
    box-shadow:none; height:auto;
}
.doubt-desk .dd-field:focus {
    outline:none; border-color:var(--dd-accent); box-shadow:0 0 0 3px rgba(54,161,245,.15);
}
.doubt-desk select.dd-field { cursor:pointer; }
.doubt-desk .dd-search { margin-top:0; }

/* ---- subject multi-select ----
   react-multi-select-component 2.0.7 declares its defaults as --rmscPrimary etc.
   but its CSS reads var(--rmsc-primary), so the theme has to be set here. */
.doubt-desk .dd-subject-select { position:relative; z-index:6; }
.doubt-desk .dd-subject-select .multi-select {
    --rmsc-primary:#36a1f5;
    --rmsc-hover:#eff6ff;
    --rmsc-selected:#e0f2fe;
    --rmsc-border:#cbd5e1;
    --rmsc-gray:#94a3b8;
    --rmsc-background:#ffffff;
    --rmsc-spacing:10px;
    --rmsc-border-radius:8px;
    --rmsc-height:38px;
    font-size:.82rem; text-align:left;
}
.doubt-desk .dd-subject-select .dropdown-container {
    border:1px solid var(--dd-border-strong) !important; border-radius:8px; background:var(--dd-surface);
}
.doubt-desk .dd-subject-select .dropdown-container:focus-within {
    border-color:var(--dd-accent) !important; box-shadow:0 0 0 3px rgba(54,161,245,.15) !important;
}
.doubt-desk .dd-subject-select .dropdown-heading { height:38px; padding:0 10px; cursor:pointer; }
.doubt-desk .dd-subject-select .dropdown-heading-value {
    color:var(--dd-text); font-weight:600;
    overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}
.doubt-desk .dd-subject-select .dropdown-heading-value.gray { color:var(--dd-faint); font-weight:500; }
/* the panel is only as wide as the control by default, which clips subject names */
.doubt-desk .dd-subject-select .dropdown-content {
    z-index:20; padding-top:3px; min-width:195px; width:100%;
}
.doubt-desk .dd-subject-select .panel-content {
    border-radius:8px; box-shadow:0 8px 24px rgba(15,23,42,.14); border:1px solid var(--dd-border);
    overflow:hidden;
}
/* _home.scss styles this same library by its goober hashes (.go977458394 etc.)
   and _CBSE_Section.scss sets a global input[type=checkbox] margin, both of which
   shove these rows around - hence the !important resets. */
.doubt-desk .dd-subject-select .select-item {
    display:flex !important; align-items:center !important;
    padding:6px 9px !important; margin:0 !important; line-height:1.25 !important;
    font-size:.75rem; color:var(--dd-text-soft); white-space:nowrap; text-align:left !important;
}
.doubt-desk .dd-subject-select .select-item .item-renderer {
    display:flex !important; align-items:center !important; width:100%; margin:0 !important;
}
.doubt-desk .dd-subject-select .select-item span {
    display:inline-block !important; flex:1 1 auto;
    padding-left:0 !important; margin-top:0 !important; text-align:left !important;
    white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}
.doubt-desk .dd-subject-select .select-item input[type="checkbox"] {
    margin:0 7px 0 0 !important; flex:0 0 auto; width:13px; height:13px;
}
.doubt-desk .dd-subject-select .select-panel li { line-height:normal !important; }
.doubt-desk .dd-subject-select .select-item.selected { background:var(--dd-accent-tint) !important; color:var(--dd-accent-dark); font-weight:600; }
.doubt-desk .dd-subject-select .select-panel > .select-item { border-bottom:1px solid var(--dd-border); }
.doubt-desk .dd-subject-select .select-item:hover { background:var(--dd-surface-mute); }
.doubt-desk .dd-subject-select .select-item .item-renderer { align-items:center; gap:8px; }
.doubt-desk .dd-subject-select .select-item input[type="checkbox"] { accent-color:var(--dd-accent); margin:0 4px 0 0; }
.doubt-desk .dd-subject-select .select-panel > .select-item:first-child {
    font-weight:700; color:var(--dd-accent-dark); border-bottom:1px solid var(--dd-border);
}
.doubt-desk .dd-subject-select .search input {
    font-size:.8rem; padding:8px 10px; border-bottom:1px solid var(--dd-border);
}
.doubt-desk .dd-thread-list { overflow-y:auto; flex:1; padding:10px; min-height:0; }
.doubt-desk .dd-thread-item {
    background:var(--dd-surface); border:1px solid var(--dd-border); border-left:3px solid transparent;
    border-radius:10px; padding:11px 12px; margin-bottom:8px; cursor:pointer;
    transition:all .25s cubic-bezier(.4,0,.2,1); box-shadow:0 1px 3px rgba(15,23,42,.02);
}
.doubt-desk .dd-thread-item:hover {
    transform:translateY(-1px); box-shadow:0 4px 8px rgba(15,23,42,.05);
    border-color:var(--dd-accent-line);
}
.doubt-desk .dd-thread-item.active {
    background:linear-gradient(135deg,#f0f9ff 0%,#e0f2fe 100%);
    border-color:#93c5fd; border-left:3px solid var(--dd-accent);
    box-shadow:0 4px 8px rgba(54,161,245,.06);
}
.doubt-desk .dd-thread-top { display:flex; justify-content:space-between; align-items:center; gap:8px; }
.doubt-desk .dd-thread-who {
    font-size:.8rem; font-weight:700; margin-top:4px; color:var(--dd-text);
    display:flex; align-items:center; gap:6px;
}
.doubt-desk .dd-thread-who span { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.doubt-desk .dd-unseen {
    font-size:.6rem; font-weight:700; flex-shrink:0; background:var(--dd-red); color:#ffffff;
    border-radius:10px; padding:1px 7px; animation:dd-pulse-glow 2s infinite;
}
@keyframes dd-pulse-glow {
    0% { transform:scale(1); box-shadow:0 0 0 0 rgba(239,68,68,.6); }
    70% { transform:scale(1.05); box-shadow:0 0 0 5px rgba(239,68,68,0); }
    100% { transform:scale(1); box-shadow:0 0 0 0 rgba(239,68,68,0); }
}
.doubt-desk .dd-thread-snip {
    font-size:.72rem; color:var(--dd-muted); margin-top:5px; line-height:1.35;
    display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
}
.doubt-desk .dd-thread-bottom {
    display:flex; justify-content:flex-end; align-items:center; margin-top:8px; gap:8px;
    border-top:1px solid var(--dd-surface-mute); padding-top:6px;
}
.doubt-desk .dd-thread-time { font-size:.65rem; color:var(--dd-faint); white-space:nowrap; }
.doubt-desk .dd-thread-subject {
    display:inline-flex; align-items:center; gap:5px; min-width:0;
    font-size:.62rem; font-weight:700; text-transform:uppercase; letter-spacing:.3px;
    color:var(--dd-text-soft); background:var(--dd-surface-mute); padding:3px 9px; border-radius:20px;
    overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
}
.doubt-desk .dd-thread-subject i { font-size:.7rem; color:var(--dd-accent); }

/* ---- status badges ---- */
.doubt-desk .dd-stamp {
    font-size:.68rem; font-weight:600; padding:3px 9px; border-radius:20px;
    border:1px solid; display:inline-block; white-space:nowrap; flex-shrink:0;
}
.doubt-desk .dd-stamp-open { color:var(--dd-amber); border-color:var(--dd-amber-line); background:var(--dd-amber-bg); }
.doubt-desk .dd-stamp-progress { color:var(--dd-blue); border-color:var(--dd-blue-line); background:var(--dd-blue-bg); }
.doubt-desk .dd-stamp-resolved { color:var(--dd-green); border-color:var(--dd-green-line); background:var(--dd-green-bg); }

/* ---- empty column ---- */
.doubt-desk .dd-empty {
    flex:1; display:flex; align-items:center; justify-content:center; flex-direction:column; gap:10px;
    color:var(--dd-faint); font-size:.85rem; text-align:center; padding:40px;
}
.doubt-desk .dd-empty .dd-glyph { font-size:2.4rem; color:var(--dd-border-strong); line-height:1; }
.doubt-desk .dd-empty-btn {
    margin-top:4px; border:1px solid var(--dd-accent); background:var(--dd-surface);
    color:var(--dd-accent); font-family:inherit; font-weight:700; font-size:.8rem;
    padding:8px 20px; border-radius:20px; cursor:pointer; transition:all .15s ease-in-out;
}
.doubt-desk .dd-empty-btn:hover { background:var(--dd-accent-tint); }

/* ---- nothing selected ---- */
.doubt-desk .dd-chat-empty {
    flex:1; display:flex; align-items:center; justify-content:center; padding:30px;
}
.doubt-desk .dd-chat-empty-card {
    background:var(--dd-surface); border:1px solid rgba(226,232,240,.9); border-radius:16px;
    box-shadow:0 8px 28px rgba(15,23,42,.07); padding:34px 38px; text-align:center; max-width:360px;
}
.doubt-desk .dd-chat-empty-icon {
    width:64px; height:64px; border-radius:50%; margin:0 auto 18px;
    background:linear-gradient(135deg,#3ddc84 0%,#22c55e 100%); color:#ffffff;
    display:flex; align-items:center; justify-content:center; font-size:1.6rem;
    box-shadow:0 0 0 8px rgba(34,197,94,.12), 0 8px 20px rgba(34,197,94,.35);
}
.doubt-desk .dd-chat-empty-card h4 {
    font-size:1.05rem; font-weight:700; color:var(--dd-text); margin:0 0 8px;
}
.doubt-desk .dd-chat-empty-card p {
    font-size:.85rem; color:#5b7897; line-height:1.5; margin:0;
}

/* ---- chat column ---- */
.doubt-desk .dd-chat {
    flex:1; display:flex; flex-direction:column; background:#f0ebe4;
    position:relative; min-width:0;
}

/* ---- scrollbars ---- */
.doubt-desk ::-webkit-scrollbar { width:5px; }
.doubt-desk ::-webkit-scrollbar-track { background:transparent; }
.doubt-desk ::-webkit-scrollbar-thumb { background:var(--dd-border-strong); border-radius:10px; }

/* ---- drawer ---- */
.create-doubt-drawer {
    position:fixed; top:0; right:0; width:480px; max-width:100vw; height:100vh;
    background:#ffffff; box-shadow:-5px 0 25px rgba(15,23,42,.15);
    z-index:2050; transform:translateX(100%);
    transition:transform .35s cubic-bezier(.16,1,.3,1);
    display:flex; flex-direction:column;
}
.create-doubt-drawer.open { transform:translateX(0); }
.drawer-overlay {
    position:fixed; top:0; left:0; width:100vw; height:100vh;
    background:rgba(15,23,42,.4); backdrop-filter:blur(3px);
    z-index:2040; opacity:0; pointer-events:none; transition:opacity .3s ease;
}
.drawer-overlay.open { opacity:1; pointer-events:auto; }
.drawer-header {
    padding:18px 24px; border-bottom:1px solid #e2e8f0; background:#f8fafc;
    display:flex; justify-content:space-between; align-items:center; flex-shrink:0;
}
.drawer-header h5 { font-size:1.05rem; font-weight:700; color:#0f172a; margin:0; }
.drawer-body { padding:24px; overflow-y:auto; flex-grow:1; background:#ffffff; }
.drawer-body::-webkit-scrollbar { width:5px; }
.drawer-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:10px; }
.drawer-close-btn {
    font-size:1.5rem; background:transparent; border:none; color:#64748b;
    line-height:1; padding:0; cursor:pointer; transition:color .15s ease;
}
.drawer-close-btn:hover { color:#0f172a; }

/* ---- responsive ---- */
@media (max-width: 991.98px) {
    .doubt-desk .dd-workspace { flex-direction:column; }
    .doubt-desk .dd-threads { width:100%; flex:1; border-right:none; border-bottom:1px solid var(--dd-border); }
}
@media (max-width: 767.98px) {
    .main-wrapper.dd-main { padding-bottom:40px; }
    .content-wrapper.dd-fit { min-height:100vh; }
    .dd-page { padding:8px; }
    /* subject + status stay side by side, the panel may spill past its control */
    .doubt-desk .dd-filter-row { flex-wrap:nowrap; gap:8px; }
    .doubt-desk .dd-filter-row .dd-subject-select { flex:1 1 0; }
    .doubt-desk .dd-filter-row .dd-field { flex:1 1 0; }
    .doubt-desk .dd-subject-select .dropdown-content { min-width:190px; max-width:calc(100vw - 40px); }
    .doubt-desk .dd-topbar-actions { width:100%; justify-content:space-between; }
    .doubt-desk .dd-topbar-actions .dd-field { flex:1 1 auto; min-width:0; }
    .doubt-desk .dd-date-range .customDaterange { width:190px !important; }
    /* the popup is a ~700px flex row (160px presets + two 270px calendars), so on a
       phone it is unusable where it sits: pin it as a full-width bottom sheet */
    .doubt-desk .dd-date-range .daterangepicker {
        position:fixed !important;
        top:auto !important; bottom:0 !important; left:0 !important; right:0 !important;
        width:auto !important; max-width:none !important;
        max-height:82vh; overflow-y:auto; overflow-x:hidden;
        flex-wrap:wrap; margin:0; padding:12px;
        border-radius:14px 14px 0 0; z-index:3001 !important;
        box-shadow:0 -8px 30px rgba(15,23,42,.25);
    }
    .doubt-desk .dd-date-range .daterangepicker:before,
    .doubt-desk .dd-date-range .daterangepicker:after { display:none !important; }
    .doubt-desk .dd-date-range .rangecontainer {
        width:100% !important; display:flex; flex-wrap:wrap; gap:6px;
    }
    .doubt-desk .dd-date-range .fromDateTimeContainer {
        width:100% !important; margin:6px 0 !important;
    }
    .doubt-desk { height:auto; min-height:0; }
    .doubt-desk .dd-topbar { flex-wrap:wrap; gap:10px; padding:12px 14px; }
    .doubt-desk .dd-new-doubt-btn { padding:9px 18px; font-size:.8rem; }
    .doubt-desk .dd-workspace { min-height:70vh; }
    .doubt-desk .dd-threads, .doubt-desk .dd-chat { min-height:60vh; }
    .doubt-desk .dd-workspace.dd-has-selection .dd-threads { display:none; }
    .doubt-desk .dd-workspace:not(.dd-has-selection) .dd-chat { display:none; }
}
`;

// Status badge colouring shared by the list, the thread head and the details page:
// open (amber) / in progress (blue) / closed (green)
export const getStampClass = (id) => {
    if (id == 3) return "dd-stamp dd-stamp-resolved";
    if (id == 2) return "dd-stamp dd-stamp-progress";
    return "dd-stamp dd-stamp-open";
};

export const getDefaultStatusName = (id) => {
    if (id == 1) return "Open";
    if (id == 2) return "In Progress";
    if (id == 3) return "Closed";
    return "Unknown";
};
